import React from 'react';
import { useSelector } from 'react-redux';
import { selectState } from '../../../../selectors';
import { GrayBackground } from '../../styled/thank-you';
import IossMiddleContent from './ioss';
const MiddleContent = () => {
    const { offer: { offerFlow, thankYouContent: { middleTextContent, }, }, } = useSelector(selectState);
    switch (offerFlow) {
        case 'ioss':
            return React.createElement(IossMiddleContent, null);
        default: {
            if (!middleTextContent)
                return null;
            return React.createElement(GrayBackground, { className: 'flex align-items-center justify-content-center' },
                React.createElement("h3", { className: 'text-center pad-all-lg', "data-ref": 'offer.thank-you.middle-content.default' }, middleTextContent));
        }
    }
};
export default MiddleContent;
